import { ReactComponent as ToolsIcon } from "../../../assets/icons/tool.svg";
import { Separator } from "../../../components/ui/common";
import DashboardCard from "../../../components/ui/dashboard/DashboardCard";
import { formatCurrency, formatCurrencyForTable } from "../../../lib/utils";
import { Vehicle } from "../../vehicle/@types";

interface VehicleMaintenanceCardProps {
  vehicle: Vehicle;
}

const VehicleMaintenanceCard: React.FC<VehicleMaintenanceCardProps> = ({
  vehicle,
}) => {
  const cards = [
    {
      label: "Total maintenance",
      value: `${formatCurrencyForTable(vehicle.fuelConsumption)}`,
      index: 0,
      icon: <ToolsIcon />,
    },
    {
      label: "Total maintenance cost",
      value: `${formatCurrency(vehicle.totalMaintenanceCost)}`,
      index: 1,
      icon: <ToolsIcon />,
    },
  ];

  return (
    <div className="flex flex-wrap gap-x-4 gap-y-4 sm:gap-x-10 sm:gap-y-6 bg-white rounded-[10px] p-4">
      {cards.map(({ label, value, index, icon }) => (
        <>
          <DashboardCard
            key={index}
            icon={icon}
            value={value}
            label={label}
            className="w-[300px]"
          />

          {index < cards?.length - 1 && <Separator />}
        </>
      ))}
    </div>
  );
};

export default VehicleMaintenanceCard;
